import { render, staticRenderFns } from "./OffcanvasLectureList.vue?vue&type=template&id=67fba032"
import script from "./OffcanvasLectureList.vue?vue&type=script&lang=js"
export * from "./OffcanvasLectureList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fba032')) {
      api.createRecord('67fba032', component.options)
    } else {
      api.reload('67fba032', component.options)
    }
    module.hot.accept("./OffcanvasLectureList.vue?vue&type=template&id=67fba032", function () {
      api.rerender('67fba032', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/OffcanvasLectureList.vue"
export default component.exports